var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import "../../components/header";
import "../../components/leftMenu";
import KnockoutModel from "../../lib/knockout_model";
import * as authorization from "../../lib/authorization";
import * as ajax from "../../app-lib/ajax_proxy";
import '../../lib/knockout_datePicker';
import "../../components/paging";
import './addMarketAndOpponet.css';
var Demo = /** @class */ (function (_super) {
    __extends(Demo, _super);
    function Demo(root) {
        var _this = _super.call(this, "", root, {}) || this;
        _this.isCheck = ko.observable(false); //是否是查看
        _this.dataId = ko.observable('0000'); //项目id  0000时新增 
        _this.local = ko.observableArray(); //省份列表
        _this.localid = ko.observable(); //省份obj
        _this.localnext = ko.observable(); //城市列表
        _this.localsomeid = ko.observable(); //城市obj
        _this.marketobj = ko.observable({
            authorId: authorization.getUserId(), authorName: authorization.getUsername(), collectionMethod: ko.observable(),
            completedArea: ko.observable(), completionQuantity: ko.observable(), constructionArea: ko.observable(), costSharing: ko.observable(),
            developmentVolume: ko.observable(), economic: ko.observable(), guidancePrice: ko.observable(),
            houseLaws: ko.observable(), id: ko.observable(), lawsPolicies: ko.observable(), lawsRegulations: ko.observable(),
            minimumWage: ko.observable(), parkingCharge: ko.observable(), partAdress: ko.observable(), partAdressInput: ko.observable(),
            partName: ko.observable(), priceSituation: ko.observable(), priceTrend: ko.observable(),
            propertyLaw: ko.observable(), rate: ko.observable(),
            saleArea: ko.observable(), saleMoney: ko.observable(), salesArea: ko.observable(), salesMoney: ko.observable(),
            socialInsurance: ko.observable(), structure: ko.observable(), propertyMethod: ko.observable(),
            theLabor: ko.observable(), vacantArea: ko.observable(), waterElectricity: ko.observable(), projects: ko.observableArray([{ projectName: '', propertyType: '', area: '', price: '', manager: '', salePrice: '', developer: '', rhTime: '' }])
        }); //市场数据
        return _this;
    }
    // 返回
    Demo.prototype.goBack = function () {
        history.go(-1);
        this.resetData();
    };
    // 新建，编辑提交
    Demo.prototype.subData = function () {
        var _this = this;
        if (!this.marketobj().partName()) {
            return window.popBox.show('请填写区域名称');
        }
        // if (this.marketobj().partName().length > 40) {
        //     return window.popBox.show('区域名称不能大于40个字符');
        // }
        if (!this.marketobj().partAdressInput()) {
            return window.popBox.show('请填写详细地理位置');
        }
        // if (this.marketobj().partAdressInput().length > 80) {
        //     return window.popBox.show('详细地理位置不能大于80个字符');
        // }
        if (!this.marketobj().economic()) {
            return window.popBox.show('请填写经济概况');
        }
        // if (this.marketobj().economic().length > 400) {
        //     return window.popBox.show('经济概况不能大于400个字符');
        // }
        if (!this.marketobj().waterElectricity()) {
            return window.popBox.show('请填写水电费');
        }
        if (this.marketobj().waterElectricity().length > 10) {
            return window.popBox.show('水电费不能大于10位数');
        }
        if (!this.marketobj().rate()) {
            return window.popBox.show('请填写税率标准');
        }
        if (this.marketobj().rate().length > 10) {
            return window.popBox.show('税率标准不能大于10位数');
        }
        if (!this.marketobj().minimumWage()) {
            return window.popBox.show('请填写最低人工工资标准');
        }
        if (this.marketobj().minimumWage().length > 10) {
            return window.popBox.show('最低人工工资标准不能大于10位数');
        }
        if (!this.marketobj().socialInsurance()) {
            return window.popBox.show('请填写社会保险标准');
        }
        if (this.marketobj().socialInsurance().length > 10) {
            return window.popBox.show('社会保险标准不能大于10位数');
        }
        if (this.marketobj().parkingCharge()) {
            if (this.marketobj().parkingCharge().length > 10) {
                return window.popBox.show('车位收费标准不能大于10位数');
            }
        }
        if (this.marketobj().constructionArea()) {
            if (this.marketobj().constructionArea().length > 10) {
                return window.popBox.show('施工面积不能大于10位数');
            }
        }
        if (this.marketobj().completedArea()) {
            if (this.marketobj().completedArea().length > 10) {
                return window.popBox.show('竣工面积不能大于10位数');
            }
        }
        if (this.marketobj().saleArea()) {
            if (this.marketobj().saleArea().length > 10) {
                return window.popBox.show('本区域商品房>销售面积不能大于10位数');
            }
        }
        if (this.marketobj().saleMoney()) {
            if (this.marketobj().saleMoney().length > 10) {
                return window.popBox.show('本区域商品房>销售金额不能大于10位数');
            }
        }
        if (this.marketobj().vacantArea()) {
            if (this.marketobj().vacantArea().length > 10) {
                return window.popBox.show('空置面积不能大于10位数');
            }
        }
        if (this.marketobj().developmentVolume()) {
            if (this.marketobj().developmentVolume().length > 10) {
                return window.popBox.show('开发量不能大于10位数');
            }
        }
        if (this.marketobj().completionQuantity()) {
            if (this.marketobj().completionQuantity().length > 10) {
                return window.popBox.show('竣工量不能大于10位数');
            }
        }
        if (this.marketobj().salesArea()) {
            if (this.marketobj().salesArea().length > 10) {
                return window.popBox.show('本区域主要发展商>销售面积不能大于10位数');
            }
        }
        if (this.marketobj().salesMoney()) {
            if (this.marketobj().salesMoney().length > 10) {
                return window.popBox.show('本区域主要发展商>销售金额不能大于10位数');
            }
        }
        // if (this.marketobj().propertyAreas()) {
        //     if (this.marketobj().propertyAreas().length > 10) {
        //         return window.popBox.show('本区域代表性项目>物业总建筑面积不能大于10位数');
        //     }
        // }
        // if (this.marketobj().propertyMoney()) {
        //     if (this.marketobj().propertyMoney().length > 10) {
        //         return window.popBox.show('本区域代表性项目>物业收费价格不能大于10位数');
        //     }
        // }
        // if (this.marketobj().sellingPrice()) {
        //     if (this.marketobj().sellingPrice().length > 10) {
        //         return window.popBox.show('本区域代表性项目>销售价格不能大于10位数');
        //     }
        // }
        var projects = [];
        for (var i = 0; i < this.marketobj().projects().length; i++) {
            if (this.marketobj().projects()[i].area || this.marketobj().projects()[i].developer || this.marketobj().projects()[i].manager || this.marketobj().projects()[i].price || this.marketobj().projects()[i].projectName || this.marketobj().projects()[i].rhTime || this.marketobj().projects()[i].propertyType) {
                if (this.marketobj().projects()[i].area) {
                    if (this.marketobj().projects()[i].area.length > 10) {
                        return window.popBox.show('本区域代表性项目>物业总建筑面积不能大于10位数');
                    }
                }
                if (this.marketobj().projects()[i].price) {
                    if (this.marketobj().projects()[i].price.length > 10) {
                        return window.popBox.show('本区域代表性项目>物业收费价格不能大于10位数');
                    }
                }
                if (this.marketobj().projects()[i].salePrice) {
                    if (this.marketobj().projects()[i].salePrice.length > 10) {
                        return window.popBox.show('本区域代表性项目>销售价格不能大于10位数');
                    }
                }
                projects.push(this.marketobj().projects()[i]);
            }
        }
        console.log(projects, '=====本区域项目数组');
        ajax.post('/api/market/' + this.dataId(), {
            authorId: this.marketobj().authorId,
            authorName: this.marketobj().authorName,
            collectionMethod: this.marketobj().collectionMethod(),
            completedArea: this.marketobj().completedArea(),
            completionQuantity: this.marketobj().completionQuantity(),
            constructionArea: this.marketobj().constructionArea(),
            costSharing: this.marketobj().costSharing(),
            // developers: this.marketobj().developers(),
            developmentVolume: this.marketobj().developmentVolume(),
            economic: this.marketobj().economic(),
            guidancePrice: this.marketobj().guidancePrice(),
            houseLaws: this.marketobj().houseLaws(),
            lawsPolicies: this.marketobj().lawsPolicies(),
            lawsRegulations: this.marketobj().lawsRegulations(),
            // manager: this.marketobj().manager(),
            minimumWage: this.marketobj().minimumWage(),
            // occupationTime: this.marketobj().occupationTime(),
            parkingCharge: this.marketobj().parkingCharge(),
            partAdress: this.localid().name + ',' + this.localsomeid().name + ',' + this.marketobj().partAdressInput(),
            partName: this.marketobj().partName(),
            priceSituation: this.marketobj().priceSituation(),
            priceTrend: this.marketobj().priceTrend(),
            // projectName: this.marketobj().projectName(),
            // propertyAreas: this.marketobj().propertyAreas(),
            propertyLaw: this.marketobj().propertyLaw(),
            propertyMethod: this.marketobj().propertyMethod(),
            // propertyMoney: this.marketobj().propertyMoney(),
            // propertyType: this.marketobj().propertyType(),
            rate: this.marketobj().rate(),
            saleArea: this.marketobj().saleArea(),
            saleMoney: this.marketobj().saleMoney(),
            salesArea: this.marketobj().salesArea(),
            salesMoney: this.marketobj().salesMoney(),
            // sellingPrice: this.marketobj().sellingPrice(),
            socialInsurance: this.marketobj().socialInsurance(),
            structure: this.marketobj().structure(),
            theLabor: this.marketobj().theLabor(),
            vacantArea: this.marketobj().vacantArea(),
            waterElectricity: this.marketobj().waterElectricity(),
            projects: projects,
        }).then(function (d) {
            if (d.status == '0') {
                if (_this.dataId() == '0000') {
                    window.popBox.show('新增成功').then(function (d) {
                        _this.goBack();
                    });
                }
                else {
                    window.popBox.show('编辑成功').then(function (d) {
                        _this.goBack();
                    });
                }
            }
        }).catch(function (err) {
            if (err.status == '2') {
                window.popBox.show(err.message);
            }
        });
    };
    // 新增一条本区域项目
    Demo.prototype.addOne = function () {
        this.marketobj().projects.push({ projectName: '', propertyType: '', area: '', price: '', manager: '', salePrice: '', developer: '', rhTime: '' });
    };
    // 删除一条
    Demo.prototype.delOne = function (index, r) {
        console.log(index, r);
        this.marketobj().projects.splice(index, 1);
    };
    // 取消
    Demo.prototype.quick = function () {
        this.resetData();
        this.goBack();
    };
    // 重置
    Demo.prototype.resetData = function () {
        if (this.dataId() == '0000') {
            this.marketobj({
                authorId: authorization.getUserId(), authorName: authorization.getUsername(), collectionMethod: ko.observable(), partAdressInput: ko.observable(), propertyMethod: ko.observable(),
                completedArea: ko.observable(), completionQuantity: ko.observable(), constructionArea: ko.observable(), costSharing: ko.observable(),
                developmentVolume: ko.observable(), economic: ko.observable(), guidancePrice: ko.observable(),
                houseLaws: ko.observable(), id: ko.observable(), lawsPolicies: ko.observable(), lawsRegulations: ko.observable(),
                minimumWage: ko.observable(), parkingCharge: ko.observable(), partAdress: ko.observable(),
                partName: ko.observable(), priceSituation: ko.observable(), priceTrend: ko.observable(),
                propertyLaw: ko.observable(), rate: ko.observable(),
                saleArea: ko.observable(), saleMoney: ko.observable(), salesArea: ko.observable(), salesMoney: ko.observable(),
                socialInsurance: ko.observable(), structure: ko.observable(),
                theLabor: ko.observable(), vacantArea: ko.observable(), waterElectricity: ko.observable(), projects: ko.observableArray([{ projectName: '', propertyType: '', area: '', price: '', manager: '', salePrice: '', developer: '', rhTime: '' }])
            });
            this.getPrivine();
        }
        else {
            this.getMarketData();
        }
    };
    Demo.prototype.clear = function () {
        this.marketobj({
            authorId: authorization.getUserId(), authorName: authorization.getUsername(), collectionMethod: ko.observable(), partAdressInput: ko.observable(), propertyMethod: ko.observable(),
            completedArea: ko.observable(), completionQuantity: ko.observable(), constructionArea: ko.observable(), costSharing: ko.observable(),
            developmentVolume: ko.observable(), economic: ko.observable(), guidancePrice: ko.observable(),
            houseLaws: ko.observable(), id: ko.observable(), lawsPolicies: ko.observable(), lawsRegulations: ko.observable(),
            minimumWage: ko.observable(), parkingCharge: ko.observable(), partAdress: ko.observable(),
            partName: ko.observable(), priceSituation: ko.observable(), priceTrend: ko.observable(),
            propertyLaw: ko.observable(), rate: ko.observable(),
            saleArea: ko.observable(), saleMoney: ko.observable(), salesArea: ko.observable(), salesMoney: ko.observable(),
            socialInsurance: ko.observable(), structure: ko.observable(),
            theLabor: ko.observable(), vacantArea: ko.observable(), waterElectricity: ko.observable(), projects: ko.observableArray([{ projectName: '', propertyType: '', area: '', price: '', manager: '', salePrice: '', developer: '', rhTime: '' }])
        });
        this.getPrivine();
    };
    // 获取省份
    Demo.prototype.getPrivine = function () {
        var _this = this;
        ajax.get('/api/ice/local', { pid: 1 }).then(function (d) {
            _this.local(d.data);
        });
    };
    //省份二级联动
    Demo.prototype.changelocal = function () {
        var _this = this;
        var id = this.localid().id;
        ajax.get("/api/ice/local", { pid: id }).then(function (d) {
            _this.localnext(d.data);
        });
    };
    Demo.prototype.getCity = function (id, city) {
        var _this = this;
        ajax.get("/api/ice/local", { pid: id }).then(function (d) {
            _this.localnext(d.data);
            for (var n = 0; n < _this.localnext().length; n++) {
                if (_this.localnext()[n].name == city) {
                    _this.localsomeid(_this.localnext()[n]);
                }
            }
        });
    };
    // 获取数据
    Demo.prototype.getMarketData = function () {
        var _this = this;
        ajax.get('/api/market/' + this.dataId()).then(function (d) {
            _this.marketobj().collectionMethod(d.data.collectionMethod);
            _this.marketobj().completedArea(d.data.completedArea);
            _this.marketobj().completionQuantity(d.data.completionQuantity);
            _this.marketobj().constructionArea(d.data.constructionArea);
            _this.marketobj().costSharing(d.data.costSharing);
            // this.marketobj().developers(d.data.developers);
            _this.marketobj().developmentVolume(d.data.developmentVolume);
            _this.marketobj().economic(d.data.economic);
            _this.marketobj().guidancePrice(d.data.guidancePrice);
            _this.marketobj().houseLaws(d.data.houseLaws);
            _this.marketobj().lawsPolicies(d.data.lawsPolicies);
            _this.marketobj().lawsRegulations(d.data.lawsRegulations);
            // this.marketobj().manager(d.data.manager);
            _this.marketobj().minimumWage(d.data.minimumWage);
            // this.marketobj().occupationTime(d.data.occupationTime);
            _this.marketobj().parkingCharge(d.data.parkingCharge);
            for (var m = 0; m < _this.local().length; m++) {
                if (_this.local()[m].name == d.data.partAdress.substring(0, d.data.partAdress.indexOf(','))) {
                    _this.localid(_this.local()[m]);
                }
            }
            _this.getCity(_this.localid().id, d.data.partAdress.substring(d.data.partAdress.indexOf(',') + 1, d.data.partAdress.lastIndexOf(',')));
            _this.marketobj().partAdressInput(d.data.partAdress.substring(d.data.partAdress.lastIndexOf(',') + 1, d.data.partAdress.length));
            _this.marketobj().partName(d.data.partName);
            _this.marketobj().priceSituation(d.data.priceSituation);
            _this.marketobj().priceTrend(d.data.priceTrend);
            // this.marketobj().projectName(d.data.projectName);
            // this.marketobj().propertyAreas(d.data.propertyAreas);
            _this.marketobj().propertyLaw(d.data.propertyLaw);
            _this.marketobj().propertyMethod(d.data.propertyMethod);
            // this.marketobj().propertyMoney(d.data.propertyMoney);
            // this.marketobj().propertyType(d.data.propertyType);
            _this.marketobj().rate(d.data.rate);
            _this.marketobj().saleArea(d.data.saleArea);
            _this.marketobj().saleMoney(d.data.saleMoney);
            _this.marketobj().salesArea(d.data.salesArea);
            _this.marketobj().salesMoney(d.data.salesMoney);
            // this.marketobj().sellingPrice(d.data.sellingPrice);
            _this.marketobj().socialInsurance(d.data.socialInsurance);
            _this.marketobj().structure(d.data.structure);
            _this.marketobj().theLabor(d.data.theLabor);
            _this.marketobj().waterElectricity(d.data.waterElectricity);
            _this.marketobj().vacantArea(d.data.vacantArea);
            // 本区域项目数组
            if (d.data.projects.length > 0) {
                _this.marketobj().projects(d.data.projects);
            }
        });
    };
    // 回到顶部
    Demo.prototype.scrollTop = function () {
        this.container.querySelector('.addMarketAndOpponet_body').scrollTop = 0;
    };
    // 页面滑动
    Demo.prototype.bodyOnScrolls = function () {
        var nodeArr = document.querySelectorAll('.flatpickr-calendar');
        for (var i = 0; i < nodeArr.length; i++) {
            if (nodeArr[i].classList.length > 2) {
                nodeArr[i].classList.remove('open');
                if (nodeArr[i].classList[2] == 'arrowTop') {
                    nodeArr[i].classList.remove('arrowTop');
                }
                else {
                    nodeArr[i].classList.remove('arrowBottom');
                }
            }
        }
    };
    return Demo;
}(KnockoutModel));
var DemoModel = /** @class */ (function (_super) {
    __extends(DemoModel, _super);
    function DemoModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DemoModel.prototype.init = function () {
        this.vm = new Demo(this.container.querySelector('.addMarketAndOpponet'));
        // console.log("eeeeeeeee");
        this.vm.bind();
    };
    DemoModel.prototype.update = function (arg) {
        var _this = this;
        this.vm.dataId('0000');
        this.vm.scrollTop();
        this.vm.clear();
        this.vm.getPrivine();
        if (arg.routeData.query.isCheck) {
            if (arg.routeData.query.isCheck == 'yes') {
                this.vm.isCheck(true);
            }
            else {
                this.vm.isCheck(false);
            }
            // this.vm.isCheck(arg.routeData.query.isCheck);
        }
        if (arg.routeData.query.dataId) {
            this.vm.dataId(arg.routeData.query.dataId);
            setTimeout(function () {
                _this.vm.getMarketData();
            }, 500);
        }
        return Promise.resolve();
    };
    DemoModel.prototype.onInitComplete = function () {
    };
    return DemoModel;
}(Page));
export default DemoModel;
